export class OperationalProvincia {

  static path = '/parametricas/';

  id: number;
  nombre: string;
  codigoAfip: string;

  constructor(id: number) {
    this.id = id;
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/operationalProvincia.model.ts